import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Motion from '@/app/components/Motion';

export interface LandingPageHeroEyebrowProps {
  readonly className?: string;
  readonly content: MessageKey;
}

const LandingPageHeroEyebrow = ({
  className,
  content,
}: LandingPageHeroEyebrowProps) => {
  const t = useTranslations();

  return (
    <Motion
      initial={{ opacity: 0 }}
      transition={{ duration: 1, type: 'tween', delay: 0.25 }}
      viewport={{ once: true }}
      whileInView={{ opacity: 1 }}
    >
      <Typography
        color="inherit"
        className={cx(
          'text-center tracking-wide uppercase lg:block lg:text-left lg:text-base',
          className,
        )}
        data-cy="landing-page-hero-eyebrow"
        Element="h1"
        variant="body-small"
        weight="bold"
      >
        {t(content)}
      </Typography>
    </Motion>
  );
};

export default LandingPageHeroEyebrow;
